import styled from 'styled-components'
import { IonPage, IonText } from '@ionic/react'

export const InvitePage = styled(IonPage)`
	display: flex;
	flex-direction: column;
	align-items: center;
`

export const InviteContentContainer = styled.div`
	background: #f3f5f4;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 20px;
`

export const InviteText = styled(IonText)`
	font-size: 22px;
	text-align: center;
`
